import {
  darken,
  lighten,
  mix,
  rgba,
} from 'polished'

// https://www.svgrepo.com/collection/cartography-icons/
// https://www.svgrepo.com/svg/359972/fire
// https://www.svgrepo.com/svg/359970/drop
// https://htmlcolorcodes.com/color-names/
// https://htmlcolorcodes.com/colors/shades-of-black/

export const baseTheme = {
  fonts: {
    primary: 'Karla',
    title: {
      lineOne: 'Gochi',
      lineTwo: 'Syne',
    },
  },
  screen: {
    small: '680px',
  },
  sizes: {
    header: '240px',
    smallHeader: '140px',
  },
}

const createTheme = ({
  primary,
  secondary,
  accent,
}: {
  primary: string,
  secondary: string,
  accent: string,
}) => ({
  ...baseTheme,
  colors: {
    palette: {
      primary,
      secondary,
      accent,
    },
    surface: {
      base: mix(0.86, primary, secondary),
      raised: mix(0.78, primary, secondary),
      glass: rgba(mix(0.74, primary, secondary), 0.66),
    },
    border: {
      soft: rgba(secondary, 0.2),
      strong: rgba(secondary, 0.34),
    },
    shadow: {
      soft: rgba(darken(0.25, secondary), 0.18),
      strong: rgba(darken(0.3, secondary), 0.35),
    },
    gradient: {
      background: `radial-gradient(circle at 14% 18%, ${rgba(accent, 0.2)} 0%, transparent 42%),
        radial-gradient(circle at 86% 8%, ${rgba(lighten(0.08, secondary), 0.14)} 0%, transparent 38%),
        linear-gradient(160deg, ${primary} 0%, ${lighten(0.04, primary)} 56%, ${mix(0.9, primary, secondary)} 100%)`,
      spotlight: `linear-gradient(128deg, ${rgba(accent, 0.9)} 0%, ${rgba(lighten(0.1, accent), 0.68)} 52%, transparent 100%)`,
    },
    get lighten() {
      return {
        primary: lighten(0.05, this.palette.primary),
        secondary: lighten(0.05, this.palette.secondary),
      }
    },
  },
})

export const lightTheme = createTheme({
  primary: '#efe5d7',  // Soft Linen
  secondary: '#163126',  // Deep Forest
  accent: '#cc6e2f',  // Clay Orange
})

export const darkTheme = createTheme({
  primary: '#0e1a15',  // Forest Night
  secondary: '#efe5d7',  // Soft Linen
  accent: '#f0a35e',  // Warm Ember
})

const theme = lightTheme

export default theme
